import React from 'react';
import { AlertTriangle } from 'lucide-react';

export const ConfirmDialog: React.FC<{
  isOpen: boolean;
  title: string;
  message: string;
  onConfirm: () => void;
  onCancel: () => void;
  onSaveToCloud?: () => void;
  confirmText?: string;
  cancelText?: string;
  saveToCloudText?: string;
}> = ({ isOpen, title, message, onConfirm, onCancel, onSaveToCloud, confirmText = "Confirm", cancelText = "Cancel", saveToCloudText = "Save to Cloud" }) => {
  if (!isOpen) return null;
  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/50 backdrop-blur-sm">
      <div className="bg-white dark:bg-slate-900 rounded-xl shadow-2xl border border-slate-200 dark:border-slate-700 w-full max-w-md p-6 transform transition-all scale-100 animate-in fade-in zoom-in duration-200">
        <div className="flex items-center gap-3 mb-4">
           <div className="p-3 bg-amber-100 dark:bg-amber-900/30 rounded-full text-amber-600 dark:text-amber-500">
             <AlertTriangle className="w-6 h-6" />
           </div>
           <h3 className="text-xl font-bold text-slate-800 dark:text-slate-100">{title}</h3>
        </div>
        <p className="text-slate-600 dark:text-slate-300 mb-8 leading-relaxed">
          {message}
        </p>
        <div className="flex flex-col sm:flex-row justify-end gap-3">
          <button 
            onClick={onCancel}
            className="px-4 py-2 text-slate-600 dark:text-slate-400 font-medium hover:bg-slate-100 dark:hover:bg-slate-800 rounded-lg transition-colors"
          >
            {cancelText}
          </button>
          <button 
            onClick={onConfirm}
            className="px-4 py-2 bg-rose-500 hover:bg-rose-600 text-white font-medium rounded-lg shadow-lg shadow-rose-500/30 transition-all"
          >
            {confirmText}
          </button>
          {onSaveToCloud && (
            <button 
              onClick={onSaveToCloud}
              className="px-4 py-2 bg-blue-500 hover:bg-blue-600 text-white font-medium rounded-lg shadow-lg shadow-blue-500/30 transition-all"
            >
              {saveToCloudText}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};
